import api from '../../redux/api';
import { SELLER_V1_BASE } from './constants';

export const sellerAuthService = {
  getProfile: async () => {
    const response = await api.get(`${SELLER_V1_BASE}/profile`);
    return response.data;
  },

  updateProfile: async (profileData) => {
    const response = await api.put(`${SELLER_V1_BASE}/profile`, profileData);
    return response.data;
  },

  uploadLogo: async (file) => {
    const formData = new FormData();
    formData.append('logo', file);
    const response = await api.post(`${SELLER_V1_BASE}/logo-upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};

export default sellerAuthService;
